import { render, staticRenderFns } from "./bar-xchart-widget.vue?vue&type=template&id=4372dc0d"
import script from "./bar-xchart-widget.vue?vue&type=script&lang=js"
export * from "./bar-xchart-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4372dc0d')) {
      api.createRecord('4372dc0d', component.options)
    } else {
      api.reload('4372dc0d', component.options)
    }
    module.hot.accept("./bar-xchart-widget.vue?vue&type=template&id=4372dc0d", function () {
      api.rerender('4372dc0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/bar-xchart-widget.vue"
export default component.exports